/* eslint-disable no-undef */

export const traeResponsablesPlataformas = async () => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/plataformas`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Access-Control-Allow-Credentials': true
        }
    });
    return response;
};

export const actualizaResponsablePlataforma = async (data) => {
    const plataforma = data.nombre;
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/plataformas/${plataforma}`, {
        method: 'PUT', // *GET, POST, PUT, DELETE, etc.
        //mode: 'cors', // no-cors, *cors, same-origin
        //cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'include', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'Access-Control-Allow-Credentials': true
        },
        //redirect: 'follow', // manual, *follow, error
        //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    return response;
};
